import { render, staticRenderFns } from "./ProgramEditorQuestion.vue?vue&type=template&id=6dfb81da&"
import script from "./ProgramEditorQuestion.vue?vue&type=script&lang=js&"
export * from "./ProgramEditorQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ProgramEditorQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports